if (typeof DynaCore_HeadingConfig == 'undefined') {
    $(document).ready(function () {
        DynaCore_HeadingConfig.init();
    });

    var DynaCore_HeadingConfig =
    {
        /**
         * Inicializace jednotlivych objektu
         */
        init: function () {
            DynaCore_HeadingConfig.patternInit();
        },

        /**
         * Zmena miniformulare behem upraveni objektu typu Button
         */
        patternInit: function () {
            // Mazani poli patternu
            $("#form-heading").off('keyup', '.pattern');
            $("#form-heading").on('keyup', '.pattern', function (e) {
                var type = $(this).parents('.tab-pane').attr('id').replace('tab-', '');
                var countPattern = (this.value.match(/%s/g) || []).length;
                var countFields = $('#tab-' + type).find('.patternField').length;
                var countDiff = (countPattern - countFields);

                if (countPattern > countFields) {
                    for (var i = 1; i <= countDiff; i++) {
                        DynaCore_HeadingConfig.patternFieldAdd(type);
                    }
                }
                if (countPattern < countFields) {
                    DynaCore_HeadingConfig.patternFieldDelete(type);
                }

                // Zadne hodnoty v paternu, vymazeme vsechna pole
                if (0 == countPattern) {
                    DynaCore_HeadingConfig.patternFieldsDelete(type);
                }
            });
        },

        /**
         * Pridani pole patternu
         */
        patternFieldAdd: function (type) {
            var span = $('#form-template-' + type + '-fields');
            var template = $(span).attr('data-template');
            var count = $('#tab-' + type).find('.patternField').length;
            var target = DynaBase_Url.getPart(0);
            var targetAlias = DynaBase_Url.getPart(1);

            template = template.replace(/__index__/g, count);

            if (count == 0) {
                $.ajax({
                    type: 'get',
                    url: '/core/field/load-fields?ta=' + target + '&taAl=' + targetAlias,
                    beforeSend: function () {
                        $('#tab-' + type).find('.pattern').prop('disabled', true).attr('disabled', true);
                    },
                    complete: function () {
                        $('#tab-' + type).find('.pattern').prop('disabled', false).attr('disabled', false).focus();
                    },
                    success: function (data) {

                        // Parse HTML
                        template = $.parseHTML(template);

                        // Remove existing options
                        $(template).find('option').not(':first').remove();

                        // Append new options
                        $.each(data, function (i, item) {
                            $(template).find('select').append($('<option value="' + item.i + '">' + item.n + '</option>'));
                        });

                        template = $(template)[0].outerHTML;

                        $(span).before(template);
                    }
                });
            } else {
                var options = $('#tab-' + type).find('.patternField').first().html();

                $(span).before(template);
                $('#tab-' + type).find('.patternField').last().html(options).prop('selectedIndex', 0);
            }
        },

        /**
         * Smazani pole patternu
         */
        patternFieldDelete: function (type) {
            $('#tab-' + type).find('.patternField').last().parents('.form-group').remove();
        },

        /**
         * Smazani vsech poli patternu
         */
        patternFieldsDelete: function (type) {
            $('#tab-' + type).find('.patternField').parents('.form-group').remove();
        }
    }
}
